// Legacy entry points kept API-compatible for existing callers. Both now render
// the redesign's kit: the bottom-centre toast pill and the token-styled
// confirm dialog.
import { useEffect } from 'react';
import { ToastPill } from './ui/Toast';
import { ConfirmDialog as KitConfirmDialog, type ConfirmDialogProps } from './ui/Modal';

const TOAST_MS = 2600;

// Toast notification component
export function Toast({
  message,
  onClose,
  type = 'success',
}: {
  message: string;
  onClose: () => void;
  type?: 'success' | 'error' | 'info';
}) {
  useEffect(() => {
    const timer = setTimeout(onClose, TOAST_MS);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message) return null;
  return <ToastPill message={message} tone={type} />;
}

// Confirmation dialog component
export function ConfirmDialog(props: Omit<ConfirmDialogProps, 'icon'>) {
  return <KitConfirmDialog {...props} />;
}
